import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import { FREEZE_LAYOUT, FREEZE_MONO, FreezeTemperature, PRESERVATION_INK, SnowflakeMark, TEMPERATURE } from './freezeUi';
import { freezeFloatSx, freezeSheenSx } from './freezeMotion';

/** The pill above a glacial heading: a glowing dot and the section's name, with a light sweep. */
export function FreezeEyebrow({ label, temperature = 'ice' }: { label: string; temperature?: FreezeTemperature }) {
  const tone = TEMPERATURE[temperature];
  return (
    <Stack
      direction="row"
      spacing={1.15}
      alignItems="center"
      sx={{
        display: 'inline-flex',
        py: 0.75,
        pl: 1.4,
        pr: 1.75,
        borderRadius: FREEZE_LAYOUT.pill,
        border: `1px solid ${PRESERVATION_INK.line}`,
        bgcolor: tone.soft,
        ...freezeSheenSx()
      }}
    >
      <Box aria-hidden sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: tone.accent, boxShadow: `0 0 0 3px ${tone.soft}` }} />
      <Typography
        sx={{
          fontFamily: FREEZE_MONO,
          fontSize: 11,
          fontWeight: 500,
          lineHeight: 1,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: tone.accent,
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
}

/** The large drifting snowflake behind a glacial surface; `sx` places and sizes it. */
export function FreezeFloatingFlake({ sx }: { sx: SxProps<Theme> }) {
  return (
    <Box
      aria-hidden
      sx={[
        { position: 'absolute', color: PRESERVATION_INK.ice, opacity: 0.09, pointerEvents: 'none', ...freezeFloatSx(9000) },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <SnowflakeMark size="100%" detailed strokeWidth={0.9} />
    </Box>
  );
}
